<template>
    <div>
        <section class="nationwide--header flex align-center end-xs">
            <div class="full-width">
                <div class="center-xs">
                    <div class="flex center-xs header-logos">
                        <a href="/">
                            <img class="samsara-logo-white" src="https://d9ylfbta65t3x.cloudfront.net/img/brand/samsara-logo-white-small.svg">
                        </a>
                        <div class="white-vertical-divider"></div>
                        <a href="/">
                            <img class="nationwide-logo-white" src="https://images.ctfassets.net/bx9krvy0u3sx/4pu4M8NWIAqhk3Ng91CEcV/a2322ef6bcfe45a3c93cd3baa1d14049/nationwide-white-horizontal.png">
                        </a>
                    </div>
                </div>
            </div>
            <div class="nationwide-marketing-image__container">
                <div class="nationwide-marketing-image__container--inner hidden-l flex" style="width: 100%; justify-content: flex-end;">
                    <img class ="nationwide-marketing-image" src="https://images.ctfassets.net/bx9krvy0u3sx/3AaDHCJWMPUCEs49yZb67A/ccb7c02c9c6c9cfd82cacd4a43158d07/ESC-0283AO_Email_CLAuto_September_Insured_IMAGEONLY.jpg" alt="">
                </div>
            </div>
        </section>

        <section v-if="!formSubmitted">
            <div class="container--form relative padding-top-2 space-bottom-2">
                <div class="row">
                    <div class="col xs-12 lg-6">
                        <h5>LIMITED TIME OFFER</h5>
                        <p>As a valued Nationwide customer, you’ve been selected for an exclusive offer – protect your rig with best-in-class dashcam technology for FREE.</p>

                        <p>We’ll send you a high-definition dash camera with embedded artificial intelligence ($350 value) + two years of monthly service ($1,228 value) PLUS special renewal pricing*.</p>

                        <br>

                        <h5>Equipment Highlights</h5>
                        <ul>
                            <li>Simple, self-installation in less than 15 minutes</li>
                            <li>Front-facing camera with auto-upload of all incident footage</li>
                            <li>Real-time GPS fleet tracking and vehicle diagnostics</li>
                            <li>Mobile Driver App with ELD data, routing & messaging</li>
                        </ul>

                        <h5>Benefits of telematics</h5>
                        <ul>
                            <li>Video footage helps protect you against false claims and legal battles</li>
                            <li>Fulfill your ELD requirement and improve fuel efficiency</li>
                            <li>Helps us develop future programs at best possible rates</li>
                        </ul>

                        <h5>Protect your rig in three simple steps</h5>
                        <ol>
                            <li>Fill out the form on your right, review the terms & conditions, and submit.</li>
                            <li>Wait for dashcam equipment to be delivered to your door within six business days.</li>
                            <li>Plug in the new dashcam and get started!</li>
                        </ol>

                        <p class="sneaky-text space-top-2">
                            * Based on meeting program KPIs and eligibility for renewal based on underwriting guidelines.
                        </p>

                        <p>For a live look, watch this video footage</p>

                        <div class="hidden-l">
                          <iframe width="460" height="280" src="https://www.youtube.com/embed/G-D1FIXHdVQ" frameborder="0">
                          </iframe>
                        </div>

                    </div>

                    <div class="col xs-12 lg-6">
                        <div style="display: block;"></div>
                            <form class="flex center-xs start-md flex-wrap" id="nationwide-form" ref="nationwideForm" name="nationwideform" v-on:submit.prevent="submitForm">
                                <div class="flex start-xs mobile-column full-width">
                                    <h5 class="space-top-0">Customer Information</h5>
                                </div>
                                <div class="flex center-xs full-width">
                                    <div class="flex mobile-column full-width">
                                        <div class="input-box start-xs">
                                            <label class="flex" for="firstname">First Name<div class="required"> *</div></label>
                                            <div class="relative">
                                                <input v-if="displayErrors && $v.firstname.$invalid" class="error" v-model="$v.firstname.$model" type="text" id="firstname" placeholder="Jane" name="firstname">
                                                <input v-else v-model="$v.firstname.$model" type="text" id="firstname" placeholder="Jane" name="firstname">
                                                <div v-if="!$v.firstname.$invalid" class="valid-check"></div>
                                            </div>
                                        </div>
                                        <div class="input-box start-xs">
                                            <label class="flex" for="lastname">Last Name<div class="required"> *</div></label>
                                            <div class="relative">
                                                <input v-if="displayErrors && $v.lastname.$invalid" class="error" v-model="$v.lastname.$model" type="text" id="lastname" placeholder="Doe" name="lastname">
                                                <input v-else v-model="$v.lastname.$model" type="text" id="lastname" placeholder="Doe" name="lastname">
                                                <div v-if="!$v.lastname.$invalid" class="valid-check"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex center-xs full-width">
                                    <div class="flex mobile-column full-width">
                                        <div class="input-box start-xs">
                                            <label class="flex" for="email">Email<div class="required"> *</div></label>
                                            <div class="relative">
                                                <input v-if="displayErrors && $v.email.$invalid" class="error" v-model="$v.email.$model" type="email" id="email" placeholder="example@company.com" name="email">
                                                <input v-else v-model="$v.email.$model" type="email" id="email" placeholder="example@company.com" name="email">
                                                <div v-if="!$v.email.$invalid" class="valid-check"></div>
                                            </div>
                                        </div>
                                        <div class="input-box start-xs">
                                            <label class="flex" for="company">Company<div class="required"> *</div></label>
                                            <div class="relative">
                                                <input v-if="displayErrors && $v.company.$invalid" class="error" v-model="$v.company.$model" type="text" id="company" placeholder="ABC Inc" name="company">
                                                <input v-else v-model="$v.company.$model" type="text" id="company" placeholder="ABC Inc" name="company">
                                                <div v-if="!$v.company.$invalid" class="valid-check"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex center-xs full-width">
                                    <div class="flex mobile-column full-width">
                                        <div class="input-box start-xs">
                                            <label class="flex" for="phone">Phone<div class="required"> *</div></label>
                                            <div class="relative">
                                                <input v-if="displayErrors && $v.phone.$invalid" class="error" v-model="$v.phone.$model" type="tel" id="phone" placeholder="(000) - 000 0000" name="phone">
                                                <input v-else v-model="$v.phone.$model" type="tel" id="phone" placeholder="(000) - 000 0000" name="phone">
                                                <div v-if="!$v.phone.$invalid" class="valid-check"></div>
                                            </div>
                                        </div>

                                        <div class="input-box start-xs">
                                            <label class="flex" for="dotNumber">DOT #<div class="required"> *</div></label>
                                            <div class="relative">
                                                <input v-if="displayErrors && $v.dotNumber.$invalid" class="error" v-model="$v.dotNumber.$model" type="tel" id="phone" placeholder="000 000 0000" name="dotNumber">
                                                <input v-else v-model="$v.dotNumber.$model" type="tel" id="dotNumber" placeholder="000 000 0000" name="phone">
                                                <div v-if="!$v.dotNumber.$invalid" class="valid-check"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex center-xs full-width">
                                    <div class="flex mobile-column full-width">
                                        <div class="input-box start-xs">
                                            <label class="flex" for="street">Street<div class="required"> *</div></label>
                                            <div class="relative">
                                                <input v-model="street" type="text" id="street" name="street" placeholder="123 Main St">
                                            </div>
                                        </div>

                                        <div class="input-box start-xs">
                                            <label class="flex" for="city">City<div class="required"> *</div></label>
                                            <div class="relative">
                                                <input v-model="city" type="text" id="city" name="city" placeholder="City">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex center-xs full-width">
                                    <div class="flex mobile-column full-width">
                                        <div class="input-box start-xs">
                                            <label class="flex" for="state">State<div class="required"> *</div></label>
                                            <div class="relative">
                                                <input v-model="state" type="text" id="state" name="state" placeholder="State">
                                            </div>
                                        </div>

                                        <div class="input-box start-xs">
                                            <label class="flex" for="zip">ZIP<div class="required"> *</div></label>
                                            <div class="relative">
                                                <input v-model="zip" type="text" id="zip" name="zip" placeholder="11111">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex start-xs full-width">
                                  <p class="sneaky-text">* PO Boxes not eligble</p>
                                </div>

                                <div class="flex center-xs full-width">
                                    <div class="flex mobile-column full-width">
                                        <div class="text-box-wrapper full-width start-xs">
                                            <label class="flex">Vehicle Identification Numbers<div class="required"> *</div></label>
                                            <textarea v-if="displayErrors && $v.vins.$invalid" class="text-box error" v-model="$v.vins.$model" cols="30" rows="10" placeholder="Please enter one VIN per line (max 10)"></textarea>
                                            <textarea v-else class="text-box" v-model="$v.vins.$model" cols="30" rows="10" placeholder="Please enter one VIN per line (max 10)"></textarea>
                                            <p v-if="vinList.length > 10" class="red-text">Cannot enter more than 10 vehicle identification numbers</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex vertical-align full-width space-top-1 space-bottom-1">
                                  <div class="flex start-xs full-width align-center">
                                    <input v-model="$v.dashCamInstallCheck.$model" type="checkbox" id="dash-cam-check" name="dash-cam-check">
                                    <label for="dash-cam-check">Check here confirming you will install the dash cam within 30 days of receiving it.
                                      <div v-if="displayErrors && $v.dashCamInstallCheck.$invalid" class="required"> * Required Field</div>
                                      <div v-else class="required"> *</div>
                                    </label>
                                  </div>
                                </div>


                                <div class="flex center-xs">
                                    <div class="flex start-xs vertical-align submit-box">
                                        <div class="space-bottom-1">
                                            <label>By clicking “Submit,” I acknowledge the receipt of the <a href="/support/privacy" target="_blank">Privacy Policy</a> and that I have reviewed the <a href="https://assets.ctfassets.net/bx9krvy0u3sx/6CU2WdeDbUVHDX33Bhgnf2/5d38fc20d019e41462d11a6784dcaf88/Terms_and_Conditions_of_the_Nationwide_Samsara_Exclusive_Offer_2.10__1_.docx">terms and conditions</a> with Nationwide.</label>
                                        </div>
                                        <div class="center-xs start-lg">
                                            <input class="form-button" @click.prevent="testSubmit" type="button" value="Submit">
                                        </div>
                                    </div>
                                </div>
                            </form>
                    </div>
                </div>
            </div>
        </section>
        <section v-else>
            <div class="container--form space-top-2">
                <div class="row">
                    <div class="col sm-12 center-text">
                        <h1>You are all set!</h1>
                        <h3>Thank you for participating in Nationwide’s E&S Non-Fleet Safety Pilot</h3>
                        <br>
                        <p>Approvals will take 1-3 business days. Once approved, Samsara will send out shipping details and “Getting Started” documentation. </p>
                        <br>
                        <p>If you have questions regarding your Samsara equipment/dashboard, please contact support@samsara.com  </p>
                        <br>
                        <p>If you have questions regarding your Nationwide policy, please contact your General Agent or reach out to telelmatics@nationwide.com </p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { minLength, required, email } from 'vuelidate/lib/validators';
import axios from 'axios';

const validPhone = (value) => /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/.test(value);

export default {
    data() {
        return {
            displayErrors: false,
            firstname: '',
            lastname: '',
            email: '',
            company: '',
            phone: '',
            dotNumber: '',
            street: '',
            city: '',
            state: '',
            zip: '',
            vins: '',
            dashCamInstallCheck: false,
            formSubmitted: false
        }
    },
    validations: {
        firstname: {
            required,
            minLength: minLength(2)
        },
        lastname: {
            required,
            minLength: minLength(2)
        },
        email: {
            required,
            email
        },
        company: {
            required,
            minLength: minLength(2)
        },
        phone: {
            required,
            validPhone
        },
        dotNumber: {
            required
        },
        vins: {
            required,
            onlyAlphaNumAndNewline(vins) {
                return !vins.match(/[^a-zA-Z0-9\n\r]/)
            },
            maxVinsAllowed() {
                return this.vinList.length <= 10;
            }
        },
        dashCamInstallCheck: {
          checked: value => value === true
        }
    },
    computed: {
        // Split textarea input into array of VIN strings
        vinList() {
            return this.vins.split(/\r?\n/);
        }
    },
    methods: {
        runValidation() {
            return !this.$v.$invalid;
        },
        testSubmit() {
            if (this.runValidation() === true) {
                this.submitForm();
            } else {
                this.displayErrors = true;
            }
        },
        async submitForm() {
            this.formSubmitted = true;

            this.$nextTick(async function () {
                let formFields = {
                    firstname: this.firstname,
                    lastname: this.lastname,
                    email: this.email,
                    company: this.company,
                    phone: this.phone,
                    dotnumber: this.dotNumber,
                    street: this.street,
                    city: this.city,
                    state: this.state,
                    zip: this.zip,
                    vins: this.vinList
                }

                try {
                    axios({
                        method: 'post',
                        url: 'https://hooks.zapier.com/hooks/catch/4679079/ox3nwbs/',
                        headers: {
                            'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
                        },
                        data: formFields
                    })
                } catch(e) {
                    Sentry.captureException(e);
                    // If the call fails, the lead data gets stored in sentry for recovery
                    Sentry.captureMessage(JSON.stringify(formFields));
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
li {
    font-size: 16px;
    line-height: 16px;
    margin-bottom: 20px;
}

.nationwide--header {
    background-image:url('https://d9ylfbta65t3x.cloudfront.net/img/landing-pages/background_display_1920x1080.png');
    background-repeat:no-repeat;
    background-size:cover;
    background-position:bottom;
    height: 248px;
}

.header-logos {
    justify-content: space-around;
    align-content: center;
    align-items: center;
    @media(max-width: 1300px) {
        flex-direction: column;
    }

    .samsara-logo-white {
        height: 80px;
        @media(max-width: 1300px) {
            height: 40px;
        }
    }

    .nationwide-logo-white {
        height:100px;
        @media(max-width: 1300px) {
            height:50px;
        }
    }

    .white-vertical-divider {
        height: 100px;
        border-left: 3px solid #FFF;
        @media(max-width: 1300px) {
            height:50px;
            margin: 20px;
        }
    }
}

.nationwide-marketing-image__container {
    max-width:50%;

    .nationwide-marketing-image__container--inner {
        width: 100%;

        .nationwide-marketing-image {
            height: 248px;
            max-width: 540px;
        }
    }
}

.container--form {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 22px;
}

.nationwide-lead-form {
    padding: 10px;
    padding-bottom: 50px;

    @media (min-width: 736px) {
        padding: 50px 10px;
    }

    @media (min-width: 1200px) {
        padding: 50px 40px;
    }
}
label {
    margin-bottom: 4px;
    font-size: 16px;
    line-height: 26px;
    font-family: Roboto;
    color: #545454;
}

input {
    padding-left: 16px;
    height: 48px;
    width: 100%;
    background: #FFFFFF;
    border: 1px solid #979797;
    box-sizing: border-box;
    border-radius: 0;

    &:focus {
        border: 3px solid #0384FB;
    }

    &.error {
        border: 3px solid #eb0045;
    }
}

input[type="checkbox"] {
  height: 24px;
  width: 20%;
}

textarea {
    &:focus {
        border: 3px solid #0384FB;
    }

    &.error {
        border: 3px solid #eb0045;
    }
}

.required {
    display: inline;
    color: #eb0045;
    margin-left: 3px;
}

.relative {
    position: relative;
}

.input-box {
    margin: 5px 10px 20px;
    position: relative;
    max-width: 330px;
    width: 100%;

    @media (min-width: 1000px) {
        margin: 5px 20px 20px 0;
        max-width: 290px;
    }
}

.mobile-full-width {
    @media (max-width: 736px) {
        max-width: 330px;
        width: 100%;
    }
}

.mobile-column {
    @media (max-width: 736px) {
        flex-direction: column;
        max-width: 330px;
        width: 100%;
    }
}

.valid-check {
    width: 17px;
    height: 17px;
    position: absolute;
    right: 15px;
    top: 17px;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='17' height='17' viewBox='0 0 17 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.42174 11.9355C5.11727 11.9355 4.812 11.8188 4.57945 11.5863L0.348823 7.35645C-0.116274 6.89135 -0.116274 6.13697 0.348823 5.67187C0.81392 5.20677 1.5683 5.20677 2.0334 5.67187L5.42174 9.06021L14.1331 0.348823C14.5982 -0.116274 15.3526 -0.116274 15.8177 0.348823C16.2828 0.81392 16.2828 1.56751 15.8177 2.0326L6.26403 11.5863C6.03148 11.8188 5.72621 11.9355 5.42174 11.9355Z' fill='%230384FB'/%3e%3c/svg%3e ");
}

.text-box-wrapper {
    margin-right: 20px;
    @media (max-width: 1000px) {
        margin: 5px 10px 20px;
    }
}

.text-box {
    max-width: 330px;
    width: 100%;

    @media (min-width: 736px) {
        max-width: 680px;
    }
}

.privacy-note {
    margin: 20px 0px;
}

.sneaky-text {
    font-size: 12px;
}

input[type=button].form-button {
    text-transform: uppercase;
    font-size: 13px;
    line-height: 15px;
    width: 200px;
    height: 48px;
    background: #0384FB;
    border-radius: 3px;
    border: none;

    &:disabled {
        background: #BCBCBC;
    }
}

.submit-box {
    flex-direction: column;
    max-width: 330px;
    width: 100%;

    @media (min-width: 736px) {
        max-width: 600px;
    }
}
</style>
